<ion-list-header mode="md">
  <ion-label class="action">Invitation Link</ion-label>

  <ion-button *ngIf="selectedLink" (click)="copyLink()" class="primary" size="small"> Copy Link </ion-button>
</ion-list-header>

<ion-item lines="full">
  <ion-icon src="/assets/icons/24px/link.svg" slot="start"></ion-icon>

  <!-- <ion-select
    *ngIf="(session && session?.confType !== 'daily') || studioSession$?.value?.confType !== 'daily'"
    [(ngModel)]="selectedLink"
    interface="popover">
    <ion-select-option *ngFor="let link of links" [value]="link">{{ link.location }}</ion-select-option>
  </ion-select> -->

  <ion-select
    *ngIf="(session && session?.confType === 'daily') || studioSession$?.value?.confType === 'daily'"
    [(ngModel)]="selectedLink"
    interface="popover">
    <ion-select-option *ngFor="let link of links" [value]="link">{{ link.location }}</ion-select-option>
  </ion-select>
</ion-item>

<ion-item *ngIf="selectedLink && selectedLink.description" id="info" lines="none">
  <ion-icon src="/assets/icons/16px/info-outline.svg" slot="start"></ion-icon>

  <ion-label class="ion-text-wrap">
    <p class="micro-regular">
      {{
        (session && session?.confType !== 'daily') || studioSession$?.value?.confType !== 'daily'
          ? selectedLink.description
          : links[0].description
      }}
    </p>
  </ion-label>
</ion-item>